import * as React from "react";
import PropTypes from "prop-types";

type SVGMaestroProps = {
  //
};

const SVGMaestro: React.FC<SVGMaestroProps> = () => {
  return <svg width="60" height="40" viewBox="0 0 70 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9" />
    <path d="M40.1899 24.2539C40.1899 31.8787 34.0796 38.0599 26.5423 38.0599C19.005 38.0599 12.8948 31.8787 12.8948 24.2539C12.8948 16.6291 19.005 10.4479 26.5423 10.4479C34.0796 10.4479 40.1899 16.6291 40.1899 24.2539Z" fill="#ED0006" />
    <path d="M57.8948 24.2539C57.8948 31.8787 51.7845 38.0599 44.2472 38.0599C36.7099 38.0599 30.5997 31.8787 30.5997 24.2539C30.5997 16.6291 36.7099 10.4479 44.2472 10.4479C51.7845 10.4479 57.8948 16.6291 57.8948 24.2539Z" fill="#0099DF" />
    <path fillRule="evenodd" clipRule="evenodd" d="M35.3948 13.7461C38.3292 16.2783 40.1898 20.0463 40.1898 24.2539C40.1898 28.4615 38.3292 32.2295 35.3948 34.7618C32.4605 32.2295 30.5998 28.4615 30.5998 24.2539C30.5998 20.0463 32.4605 16.2783 35.3948 13.7461Z" fill="#6C6BBD" />
  </svg>
};

SVGMaestro.propTypes = {
  //
};

export default SVGMaestro;
